import React, { useState, Fragment, useEffect } from "react";
import "./styles.css";
import data from "common/assets/files/country_code_flag_number.json";
import OutsideClickHandler from "react-outside-click-handler";

interface DialCodePickerProps {
  inputValue: string;
  showPicker: Boolean;
  setShowPicker: any;
  setCountryData: any;
  setIsMobile: any;
  onlyMobile: Boolean;
}

export interface CountryCodeData {
  code: string;
  flag: string;
}

function DialCodePicker(props: DialCodePickerProps) {
  // Disp or nor the Dial Code
  useEffect(() => {
    if (!props.onlyMobile) {
      if (props.inputValue != "") {
        if (props.inputValue.match(/.*[a-zA-Z@]+.*/)) {
          props.setIsMobile(false);
        } else {
          props.setIsMobile(true);
        }
      } else {
        props.setIsMobile(false);
      }
    }
  }, [props.inputValue]);

  return (
    <Fragment>
      {props.showPicker ? (
        <OutsideClickHandler onOutsideClick={() => props.setShowPicker(false)}>
          <div
            id="suggestionContainer"
            className={props.showPicker ? "showPick" : ""}
          >
            {data.map((country) => {
              return (
                <div
                  key={country.name}
                  className="suggestionCountry"
                  onClick={() => {
                    props.setCountryData({
                      code: country.number,
                      flag: country.flag,
                    });
                    props.setShowPicker(false);
                  }}
                >
                  <img
                    src={country.flag}
                    height={"15px"}
                    width={"30px"}
                    className="flag"
                  />{" "}
                  &nbsp; {country.name} &nbsp;({country.number})
                </div>
              );
            })}
          </div>
        </OutsideClickHandler>
      ) : null}
    </Fragment>
  );
}
export default DialCodePicker;
